/* ═══════════════════════════════════════════════════════
   AMIE LIBIDO QUIZ V2 — Standalone JS
   CRITICAL: NO bare apostrophes in any strings.
   All contractions use \u2019 (right single quote).
   ═══════════════════════════════════════════════════════ */
(function() {
  "use strict";

  // ═══════════════════════════════════════
  // STATE
  // ═══════════════════════════════════════
  var answers = {};
  var multiSelections = {};
  var userName = "";
  var totalDisplayQs = 10;

  // Flow: 1 -> v1 -> 2 -> 3 -> edu1 -> 4 -> 4b -> 5 -> edu2 -> 6 -> 7 -> 8 -> 9 -> loading -> results
  var flow = ["1","v1","2","3","edu1","4","4b","5","edu2","6","7","8","9"];
  var currentFlowIndex = 0;

  var progressMap = {
    "1":8, "v1":10, "2":18, "3":27, "edu1":30,
    "4":40, "4b":50, "5":58, "edu2":62,
    "6":72, "7":82, "8":92, "9":100
  };

  // Maps each flow key to a display question number (null = not a question)
  var displayQNum = {
    "1":1, "v1":null, "2":2, "3":3, "edu1":null,
    "4":4, "4b":5, "5":6, "edu2":null,
    "6":7, "7":8, "8":9, "9":10
  };

  var stepLabels = {
    "1": "Q1_current_situation",
    "v1": "validation_1",
    "2": "Q2_how_long",
    "3": "Q3_what_tried",
    "edu1": "education_mechanism",
    "4": "Q4_daily_impact",
    "4b": "Q4b_cost_anchoring",
    "5": "Q5_desired_outcome",
    "edu2": "education_hormone_cliff",
    "6": "Q6_age_range",
    "7": "Q7_hormonal_meds",
    "8": "Q8_email_capture",
    "9": "Q9_prescription_readiness"
  };

  // ─── FIRST-PARTY TRACKING: quiz loaded ───
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "quiz_start",
    quiz_name: "libido_v2",
    quiz_step: "1",
    quiz_step_label: "Q1_current_situation",
    quiz_step_number: 1,
    quiz_total_steps: flow.length
  });

  // ═══════════════════════════════════════
  // DOM REFS
  // ═══════════════════════════════════════
  function $(id) { return document.getElementById(id); }
  function qa(sel) { return document.querySelectorAll(sel); }

  // ═══════════════════════════════════════
  // SINGLE SELECT
  // ═══════════════════════════════════════
  window.qlv2Select = function(card, qNum) {
    var slide = card.closest(".qlv2-slide");
    slide.querySelectorAll(".qlv2-option").forEach(function(c) {
      c.classList.remove("selected");
    });
    card.classList.add("selected");
    answers[qNum] = card.querySelector(".qlv2-option-title").textContent;

    // ─── TRACKING: answer selected ───
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "quiz_answer",
      quiz_name: "libido_v2",
      quiz_step: String(qNum),
      quiz_step_label: stepLabels[String(qNum)] || ("Q" + qNum),
      quiz_answer: answers[qNum]
    });

    var ctaWrap = $("qlv2-cta-" + qNum);
    if (ctaWrap) {
      var btn = ctaWrap.querySelector(".qlv2-cta-btn");
      if (btn) btn.classList.add("active");
    }
  };

  // ═══════════════════════════════════════
  // MULTI SELECT
  // ═══════════════════════════════════════
  window.qlv2Multi = function(card, qNum) {
    card.classList.toggle("selected");

    if (!multiSelections[qNum]) multiSelections[qNum] = new Set();
    var label = card.querySelector(".qlv2-option-title").textContent;
    if (card.classList.contains("selected")) {
      multiSelections[qNum].add(label);
    } else {
      multiSelections[qNum].delete(label);
    }

    var ctaWrap = $("qlv2-cta-" + qNum);
    if (ctaWrap) {
      var btn = ctaWrap.querySelector(".qlv2-cta-btn");
      if (btn) {
        if (multiSelections[qNum].size > 0) {
          btn.classList.add("active");
        } else {
          btn.classList.remove("active");
        }
      }
    }
  };

  // ═══════════════════════════════════════
  // NAVIGATION
  // ═══════════════════════════════════════
  window.qlv2Next = function(fromQ) {
    currentFlowIndex++;
    if (currentFlowIndex >= flow.length) return;
    transition(flow[currentFlowIndex]);
  };

  function transition(toKey) {
    // ─── TRACKING ───
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "quiz_step",
      quiz_name: "libido_v2",
      quiz_step: toKey,
      quiz_step_label: stepLabels[toKey] || toKey,
      quiz_step_number: flow.indexOf(toKey) + 1,
      quiz_total_steps: flow.length
    });

    // Exit current
    qa(".qlv2-slide").forEach(function(s) {
      if (s.classList.contains("active")) {
        s.classList.remove("active");
        s.classList.add("exit-left");
      }
    });

    // Enter next
    setTimeout(function() {
      qa(".qlv2-slide").forEach(function(s) { s.classList.remove("exit-left"); });
      var nextSlide = document.querySelector('.qlv2-slide[data-q="' + toKey + '"]');
      if (nextSlide) {
        nextSlide.classList.add("active");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 350);

    // Update progress bar fill
    var pct = progressMap[toKey] || 0;
    $("qlv2-progressFill").style.width = pct + "%";

    // Update progress count
    var dqn = displayQNum[toKey];
    var countEl = $("qlv2-progressCount");
    if (dqn !== null && dqn !== undefined) {
      if (toKey === "9") {
        countEl.innerHTML = "<strong>Last step</strong>";
      } else {
        countEl.innerHTML = "Question <strong>" + dqn + "</strong> of " + totalDisplayQs;
      }
    } else {
      // Validation or education interstitial
      countEl.innerHTML = "<strong>Analyzing...</strong>";
    }

    // Auto-advance validation interstitials (v1 only)
    if (toKey === "v1") {
      setTimeout(function() {
        currentFlowIndex++;
        if (currentFlowIndex < flow.length) transition(flow[currentFlowIndex]);
      }, 3500);
    }
    // Education interstitials (edu1, edu2) have continue buttons — do NOT auto-advance
  }

  // ═══════════════════════════════════════
  // FORM VALIDATION (Q8)
  // ═══════════════════════════════════════
  window.qlv2CheckForm = function() {
    var name = $("qlv2-inputName").value.trim();
    var email = $("qlv2-inputEmail").value.trim();
    var valid = name.length > 0 && email.indexOf("@") > -1 && email.indexOf(".") > -1;
    var ctaWrap = $("qlv2-cta-8");
    if (ctaWrap) {
      var btn = ctaWrap.querySelector(".qlv2-cta-btn");
      if (btn) {
        if (valid) {
          btn.classList.add("active");
        } else {
          btn.classList.remove("active");
        }
      }
    }
  };

  // ═══════════════════════════════════════
  // SUBMIT QUIZ
  // ═══════════════════════════════════════
  window.qlv2Submit = function() {
    var name = $("qlv2-inputName").value.trim();
    var email = $("qlv2-inputEmail").value.trim();
    if (!name || email.indexOf("@") < 0) return;

    userName = name.charAt(0).toUpperCase() + name.slice(1);

    // ─── TRACKING ───
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "quiz_submit",
      quiz_name: "libido_v2",
      quiz_step_label: "email_submitted",
      user_email: email,
      user_name: name
    });

    if (typeof fbq === "function") {
      fbq("track", "Lead", { content_name: "libido_quiz_v2" });
    }

    var quizPayload = {
      email: email,
      name: name,
      source: "libido_quiz_v2",
      answers: answers,
      multiSelections: {},
      products: ["spark"]
    };
    for (var key in multiSelections) {
      quizPayload.multiSelections[key] = Array.from(multiSelections[key]);
    }
    fetch("https://patient.tryamie.com/api/quiz-results", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(quizPayload)
    }).catch(function() {});

    // Show loading overlay
    var overlay = $("qlv2-loadingOverlay");
    overlay.classList.add("visible");

    var steps = ["qlv2-ls1","qlv2-ls2","qlv2-ls3","qlv2-ls4"];
    steps.forEach(function(id, i) {
      setTimeout(function() { $(id).classList.add("done"); }, 700 + (i * 900));
    });

    setTimeout(function() {
      overlay.classList.remove("visible");
      $("qlv2-quizContent").style.display = "none";
      $("qlv2-progressWrap").style.display = "none";

      buildResultsPage();

      var resultsEl = $("qlv2-resultsPage");
      resultsEl.style.display = "block";
      setTimeout(function() {
        resultsEl.classList.add("visible");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);

      // ─── TRACKING ───
      window.dataLayer.push({
        event: "quiz_step",
        quiz_name: "libido_v2",
        quiz_step: "results",
        quiz_step_label: "results_page",
        quiz_step_number: flow.length + 2,
        quiz_total_steps: flow.length + 2
      });

      if (typeof fbq === "function") {
        fbq("track", "ViewContent", {
          content_name: "libido_quiz_v2_results",
          content_type: "product",
          content_ids: ["spark"],
          value: 99.00,
          currency: "USD"
        });
      }
    }, 4200);
  };

  // ═══════════════════════════════════════
  // BUILD CONSOLIDATED RESULTS PAGE
  // ═══════════════════════════════════════
  function buildResultsPage() {
    // 1. SCORE
    var timeline = answers["2"] || "";
    var impacts = multiSelections["4"] ? multiSelections["4"].size : 0;

    var baseScore = 20;
    if (timeline.indexOf("few weeks") > -1) baseScore = 32;
    else if (timeline.indexOf("few months") > -1) baseScore = 28;
    else if (timeline.indexOf("6 months") > -1) baseScore = 24;
    else if (timeline.indexOf("Over a year") > -1) baseScore = 20;
    else if (timeline.indexOf("remember") > -1) baseScore = 18;

    var impactPenalty = Math.min(impacts * 2, 10);
    var finalScore = Math.max(15, baseScore - impactPenalty);

    $("qlv2-scoreNumber").textContent = finalScore;
    $("qlv2-scoreMarker").style.left = finalScore + "%";
    $("qlv2-scoreMarker").textContent = finalScore;

    var statusText = "CRITICAL ATTENTION NEEDED";
    if (finalScore >= 30) statusText = "SEVERE \u2014 NEEDS PROTOCOL";
    $("qlv2-scoreStatus").textContent = statusText;

    // 2. PERSONALIZATION
    var q1Answer = answers["1"] || "The desire used to be there \u2014 now it\u2019s gone";
    var q2Answer = answers["2"] || "Over a year";
    var impactsArray = multiSelections["4"] ? Array.from(multiSelections["4"]) : ["Growing distance in my relationship"];
    var impactsList = impactsArray.slice(0, 2).join(", ").toLowerCase();

    $("qlv2-profileP1").innerHTML =
      "<strong>You reported:</strong> \u201C" + q1Answer + "\u201D";
    $("qlv2-profileP2").innerHTML =
      "<strong>This has been going on for:</strong> " + q2Answer + ".";
    $("qlv2-profileP3").innerHTML =
      "<strong>It\u2019s affecting:</strong> " + impactsList + ".";

    // 3. PROTOCOL TITLE
    var goal = answers["5"] || "All of the above \u2014 honestly, I want it all back";
    var protocolTitles = {
      "Feeling like myself again \u2014 the real me": "Your Hormonal Foundation Protocol",
      "Reconnecting with my partner on a deeper level": "Your Intimacy Restoration Protocol",
      "Getting my confidence and energy back": "Your Confidence & Energy Protocol",
      "Not dreading intimacy anymore": "Your Desire Recovery Protocol",
      "All of the above \u2014 honestly, I want it all back": "Your Complete Renewal Protocol"
    };
    var protocolName = protocolTitles[goal] || "Your Complete Renewal Protocol";
    $("qlv2-protocolTitle").textContent = protocolName;

    // 4. PROTOCOL PRICING
    var sparkPriceEl = document.getElementById("qlv2-sparkPrice");
    if (sparkPriceEl) sparkPriceEl.innerHTML =
      "<span class=\"qlv2-price-subscribe\">Subscribe: <strong>$99/mo</strong></span>" +
      "<span class=\"qlv2-price-onetime\">One-time: $149</span>";

    // 5. COST COMPARISON
    var costAnswer = answers["4b"] || "$200\u2013500";
    var costMap = {
      "Under $50": "$50",
      "$50\u2013200": "$200",
      "$200\u2013500": "$500",
      "$500\u20131,000": "$1,000",
      "Over $1,000": "$1,000+"
    };
    var spentDisplay = costMap[costAnswer] || "$500";
    $("qlv2-costSpent").textContent = spentDisplay;

    var savingsMap = {
      "Under $50": "Start for less than a nice dinner out",
      "$50\u2013200": "Your Amie protocol costs less per month than what you\u2019ve already spent",
      "$200\u2013500": "You\u2019ve spent more on things that didn\u2019t work than 3 months of Amie",
      "$500\u20131,000": "You\u2019ve spent 3\u20137x more on failed solutions than a full Amie protocol",
      "Over $1,000": "You\u2019ve spent 7x+ more on failed solutions than a full Amie protocol"
    };
    $("qlv2-costSavings").textContent = savingsMap[costAnswer] || "Amie costs a fraction of what you\u2019ve already tried";

    // 5. TESTIMONIAL MATCHING
    var age = answers["6"] || "35\u201344";
    var testimonials = {
      "25\u201334": {
        quote: "I was 28 and felt broken. My doctor said I was \u2018too young\u2019 for this. Amie took me seriously. Three weeks in, I felt like a completely different person.",
        attr: "Jessica R. \u00b7 31 \u00b7 Austin \u00b7 6-week patient"
      },
      "35\u201344": {
        quote: "I took this exact quiz on a Tuesday night after my kids went to bed. By Friday I had a real doctor reviewing my case. Three weeks later I initiated for the first time in over a year. This changed my marriage.",
        attr: "Michelle T. \u00b7 38 \u00b7 Chicago \u00b7 5-week patient"
      },
      "45\u201354": {
        quote: "After menopause started, I thought this part of my life was over. My Amie provider explained exactly what was happening hormonally and built me a protocol. Within a month I felt 10 years younger.",
        attr: "Linda K. \u00b7 49 \u00b7 Denver \u00b7 8-week patient"
      },
      "55\u201364": {
        quote: "At 58, I assumed low desire was just part of aging. My Amie doctor showed me the hormone data and started me on a protocol. My husband noticed the change before I did.",
        attr: "Carol M. \u00b7 58 \u00b7 Nashville \u00b7 6-week patient"
      },
      "65+": {
        quote: "I almost didn\u2019t take this quiz. I\u2019m so glad I did. My provider was compassionate, professional, and the protocol has given me back something I thought was gone forever.",
        attr: "Patricia W. \u00b7 67 \u00b7 Scottsdale \u00b7 10-week patient"
      }
    };
    var tData = testimonials[age] || testimonials["35\u201344"];
    $("qlv2-testimonialQuote").textContent = "\u201C" + tData.quote + "\u201D";
    $("qlv2-testimonialAttr").innerHTML = "<strong>" + tData.attr.split(" \u00b7 ")[0] + "</strong> \u00b7 " + tData.attr.split(" \u00b7 ").slice(1).join(" \u00b7 ");

    // 6. TIMELINE PERSONALIZATION
    $("qlv2-tlTitle").innerHTML = userName + ", here\u2019s what the next 8 weeks look like:";

    // 7. BOTTOM STAT
    $("qlv2-bottomStat").innerHTML = "<strong>68%</strong> of women with your profile see dramatic improvement within 60 days";
  }

  // ═══════════════════════════════════════
  // EDUCATION INTERSTITIAL CONTINUE
  // ═══════════════════════════════════════
  window.qlv2EduContinue = function() {
    currentFlowIndex++;
    if (currentFlowIndex < flow.length) transition(flow[currentFlowIndex]);
  };

  // ═══════════════════════════════════════
  // ADD TO CART
  // ═══════════════════════════════════════
  window.qlv2AddToCart = function() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "quiz_cta_click", quiz_name: "libido_v2", quiz_step_label: "add_to_cart" });
    if (typeof fbq === "function") {
      fbq("track", "AddToCart", { content_ids: ["spark"], content_type: "product", value: 99.00, currency: "USD" });
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: 49309993337069, quantity: 1, selling_plan: 9595027693 }] })
    }).then(function() {
      window.location.href = "/checkout";
    }).catch(function(err) {
      window.location.href = "/cart";
    });
  };

  // ═══════════════════════════════════════
  // CTA CLICK
  // ═══════════════════════════════════════
  window.qlv2CTA = function() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "quiz_cta_click",
      quiz_name: "libido_v2",
      quiz_step_label: "results_cta_click"
    });
    // Link href handles navigation — this just fires the event
  };

  // ═══════════════════════════════════════
  // TICKER (live count)
  // ═══════════════════════════════════════
  var counts = [47,52,44,49,53,46,51,48];
  var ci = 0;
  setInterval(function() {
    ci = (ci + 1) % counts.length;
    var els = document.querySelectorAll("[id^='qlv2-liveCount']");
    els.forEach(function(el) { el.textContent = counts[ci]; });
  }, 7000);

  // ═══════════════════════════════════════
  // HORMONE CLIFF CHART ANIMATION
  // ═══════════════════════════════════════
  var edu2Observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.target.classList && m.target.classList.contains("active") && m.target.getAttribute("data-q") === "edu2") {
        animateCliffChart();
      }
    });
  });

  function initCliffObserver() {
    var edu2Slide = document.querySelector('.qlv2-slide[data-q="edu2"]');
    if (edu2Slide) {
      edu2Observer.observe(edu2Slide, { attributes: true, attributeFilter: ["class"] });
    }
  }

  function animateCliffChart() {
    var bars = document.querySelectorAll(".qlv2-cliff-bar");
    var heights = ["120px","96px","66px","42px","28px"];
    bars.forEach(function(bar, i) {
      setTimeout(function() {
        bar.style.height = heights[i] || "28px";
      }, 200 + i * 150);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCliffObserver);
  } else {
    initCliffObserver();
  }

})();
